import * as React from "react";
var context = React.createContext([]);
export var CrateContextProvider = context.Provider;
export var CrateContextConsumer = context.Consumer;
//# sourceMappingURL=crate.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/context/crate.js
// module id = 200
// module chunks = 0